/**
 * Controller for the vd-banner component.
 *
 * @class BannerController
 */
export default class BannerController {
  constructor($element) {
    'ngInject'
    this._$element = $element
  }

  $onInit() {
    const $element = this._$element

    switch (this.type) {
      case 'negative':
        this.icon = 'fa-warning'
        break
      case 'success':
        break
      case 'info':
      default:
        this.icon = 'fa-info-circle'
        this.type = 'info'
        break
    }

    $element.addClass(`vd-banner vd-banner--${this.type}`)
    $element.attr('role', 'alert')

    this.showBanner = true
    this.showFeedback = false
  }

  toggleFeedback(shouldShow) {
    this.showFeedback = shouldShow
  }

  toggleBanner(shouldShow) {
    this.showBanner = shouldShow
    this._$element.toggleClass('vd-banner--dismissed', !shouldShow)
  }
}
